$('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-with-zoom',
      iframe: {
              markup: '<div class="mfp-iframe-scaler">'+
                  '<div class="mfp-close"></div>'+
                  '<iframe class="mfp-iframe" frameborder="0" allowfullscreen allow="autoplay *; fullscreen *"></iframe>'+
                  '</div>',
              patterns: {
                  youtube: {
                      index: 'youtube.com/',
                      id: function(url) {
                          var m = url.match(/[\\?\\&]v=([^\\?\\&]+)/);
                          if ( !m || !m[1] ) return null;
                          return m[1];
                      },
                      src: '//www.youtube.com/embed/%id%?autoplay=1&iframe=true'
                  },
                  vimeo: {
                      index: 'vimeo.com/',
                      id: function(url) {
                      console.log(url);
                          var m = url.match(/(?:https?:\/\/)?(?:www\.)?(?:player\.)?vimeo\.com\/(?:[a-z]\/)?(\d{6,11})[?]?.*/i);
                      console.log(m);
                          if ( !m || !m[1] ) return null;
                          return m[1];
                      },
                      src: '//player.vimeo.com/video/%id%?autoplay=1'
                  }
            }
      }
  });